module.exports = "/fonts/FiraSans-Light.ttf";